export { SentryWebOptions, SentryWebFeature, sentryWebFeature } from './SentryWebFeature'
export * from './types'
